export function mapValuesToArray(inMap: Map<any, any>): any[] {
	return Array.from(inMap.values());
}
